import { useEffect, useState } from "react";
import { MoveUp } from "lucide-react";

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 100);
    };

    // initial check (page reload mid-scroll)
    toggleVisibility();

    window.addEventListener("scroll", toggleVisibility, { passive: true });
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-6 right-6 w-12 h-12 flex items-center justify-center rounded-full bg-yellow-400 text-white shadow-lg hover:bg-yellow-500 transition-all duration-300 z-50
      ${visible ? "opacity-100 scale-100" : "opacity-0 scale-90 pointer-events-none"}`}
      aria-label="Scroll to top"
      type="button"
    >
      <MoveUp className="w-5 h-5" />
    </button>
  );
};

export default ScrollButton;